import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import get from 'lodash/get';
export const SUCCESS_STATUS_CODE = 200;
export var callbackActionsEnum;
(function (callbackActionsEnum) {
    callbackActionsEnum["RESET_DATA_MODAL"] = "RESET_DATA_MODAL";
    callbackActionsEnum["CALL_BACK_REQUEST"] = "CALL_BACK_REQUEST";
    callbackActionsEnum["CALL_BACK_SUCCESS"] = "CALL_BACK_SUCCESS";
    callbackActionsEnum["CALL_BACK_ERROR"] = "CALL_BACK_ERROR";
})(callbackActionsEnum || (callbackActionsEnum = {}));
export function submitCallMeBackData(payload) {
    return (dispatch) => {
        dispatch({
            type: callbackActionsEnum.CALL_BACK_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/self-serve/helpcenter/callback',
            action: callbackActionsEnum.CALL_BACK_REQUEST
        }), payload).then(data => {
            if (isValidResponse(data['RESPONSE'])) {
                dispatch({
                    type: callbackActionsEnum.CALL_BACK_SUCCESS,
                    data: data['RESPONSE']
                });
            }
            else {
                dispatch({
                    type: callbackActionsEnum.CALL_BACK_ERROR,
                    error: {}
                });
            }
        }, error => {
            dispatch({
                type: callbackActionsEnum.CALL_BACK_ERROR,
                error
            });
        });
    };
}
export function resetDataModal() {
    return (dispatch) => {
        dispatch({
            type: callbackActionsEnum.RESET_DATA_MODAL
        });
    };
}
export function isValidResponse(response) {
    const status = response && get(response, ['status']);
    if (status && status === SUCCESS_STATUS_CODE) {
        return true;
    }
    return false;
}
